import { render } from "./AddFileDialogue.vue?vue&type=template&id=0cd97535&scoped=true"
import script from "./AddFileDialogue.vue?vue&type=script&lang=js"
export * from "./AddFileDialogue.vue?vue&type=script&lang=js"

import "./AddFileDialogue.vue?vue&type=style&index=0&id=0cd97535&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd97535"]])

export default __exports__